import { VisitsList } from '../job/VisitsList';

export const VisitsResults = ({ job }) => {
  return (
    <div>
      <VisitsList job={job} />
    </div>
  );
};
